/**
 * 浏览器环境常量
 */

// 获取地址栏参数
export const getQueryString = (name: string) => {
    const params = window.location.href.split("?")[1];
    if (!params) return null;
    const vars = params.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1]);
        if (name === key) {
            // 如果匹配到对应key返回
            return value;
        }
    }
    return null;
};

export enum EnvType {
    Wx,
    WxWork,
    Web
}

/**
 * 微信常用工具
 */
class WxUtils {
    /**
     * 获取当前浏览器的环境
     * 一般浏览器/微信/企业微信
     */
    public getEnv(): EnvType {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.includes("wxwork")) {
            return EnvType.WxWork;
        }
        if (ua.includes("micromessenger")) {
            return EnvType.Wx;
        }
        return EnvType.Web;
    }

    /**
     * 当前环境是否为企业微信
     */
    public isWxWork(): boolean {
        return EnvType.WxWork === this.getEnv();
    }

    /**
     * 获取code
     */
    public getCode(): string | null {
        return getQueryString("code");
    }

    /**
     * 生成企业微信配置路径,能够获取code
     */
    public generateWwxUrl() {
        // const redirectUrl = sessionStorage.getItem("toPath") as string;
        let generateUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?";
        generateUrl += "appid=" + import.meta.env.VITE_APP_ID;
        generateUrl += "&response_type=code&scope=snsapi_base";
        generateUrl += "&agentid=" + import.meta.env.VITE_AGENT_ID;
        // 拼接重定向地址
        generateUrl += "&redirect_uri=" + this.getRedirectUri();
        
        // if (redirectUrl) {
        //     // 去除重复的 '/'
        //     const url =
        //         import.meta.env.VITE_DOMAIN_NAME + import.meta.env.VITE_PUBLIC_PATH + redirectUrl.replace("/", "");
        //     generateUrl += "?url=" + url;
        // }
        generateUrl += "#wechat_redirect";
        console.log("企微重定向地址", generateUrl);
        return generateUrl;
    }

    getRedirectUri() {
        return joinPath(import.meta.env.VITE_DOMAIN_NAME, import.meta.env.VITE_PUBLIC_PATH, "/login");
    }

    // 跳转到自动登录页面
    goAutoLogin() {
        window.location.href = this.generateWwxUrl();
    }
}

/**
 * 合并路径
 */
function joinPath(base: string, ...paths: string[]) {
  const segments = [base, ...paths]
    .filter(p => p !== undefined && p !== null && p !== '') // 去掉空
    .map((p, index) => {
      if (index === 0) {
        // base 去掉末尾 /
        return p.replace(/\/+$/, '')
      }
      // 其他 path 去掉首尾 /
      return p.replace(/^\/+|\/+$/g, '')
    })
    .filter(Boolean)

  return segments.join('/')
}

const wxUtils = new WxUtils();
export default wxUtils;
